import React from 'react'
import './SingleGroupChatMessage.css'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { SpectrumVisualizer, SpectrumVisualizerTheme } from 'react-audio-visualizers';

function index({you, message, name, time, type, voiceNoteUrl}) {

  function formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

  
  return (
    <div className={`single__chat__message ${you && 'your__message'}`}>
      <p className="name"><p>{you ? 'you' : name}</p></p>
      {message && <p className="message">{message}</p>}
      {/* {voiceNoteUrl && 
        (<SpectrumVisualizer
          audio={voiceNoteUrl}
          theme={SpectrumVisualizerTheme.radialSquaredBars}
          colors={['#009688', '#26a69a']}
          iconsColor="#26a69a"
          backgroundColor="white"
          showMainActionIcon
          // showLoaderIcon
          highFrequency={8000}
        />)
      } */}
      {voiceNoteUrl && 
        (<audio controls>
          <source src={voiceNoteUrl} type="audio/wav" />
          Your browser does not support the audio tag.
         </audio>)
      }
      <span className='message__time'>
        <span className="reply__btn">
          <KeyboardArrowDownIcon />
        </span>
        {formatAMPM(new Date(time))}
      </span>
    </div>
  )
}

export default index
